export default {"src":"/_next/static/media/dawn-logo.d6e5226b.svg","height":32,"width":107};